<app-modal-header (closeModal)="close()" />
<app-modal-body>
  <div class="row pb-4">
    <div class="col-md-12 col-12 mx-auto text-center">
      <canvas #qrCanvas></canvas>
      <p class="mb-0">{{ 'SCAN_MY_QR_CODE_TO_CHECK_EVENT' | translate }}</p>
    </div>
  </div>
</app-modal-body>
